class PredictiveSearch extends SearchForm {
	constructor() {
		super();
		console.log('[DEBUG] PredictiveSearch constructor called');
		this.cachedResults = {};
		this.predictiveSearchResults = this.querySelector(
			"[data-predictive-search]",
		);
		console.log('[DEBUG] predictiveSearchResults:', !!this.predictiveSearchResults);
		this.allPredictiveSearchInstances =
			document.querySelectorAll("predictive-search");
		console.log('[DEBUG] allPredictiveSearchInstances count:', this.allPredictiveSearchInstances.length);
		this.isOpen = false;
		this.abortController = new AbortController();
		this.searchTerm = "";
		this.body = document.querySelector("body");
		this.headerBottom = document.querySelector(".header__bottom");
		this.promoModal = document.querySelector(".search__modal");
		this.headerInput = document.querySelector(".search-modal .search__input");
		console.log('[DEBUG] input:', !!this.input, 'headerInput:', !!this.headerInput, 'promoModal:', !!this.promoModal);
		console.log('[DEBUG] routes.predictive_search_url:', typeof routes !== 'undefined' ? routes.predictive_search_url : 'routes not defined');
		this.calcHeight();
		this.setupEventListeners();

		const searchResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;

			if (entry.contentRect.width < 991) {
				this.calcHeight(65);
			} else {
				this.calcHeight(0);
			}
		});

		searchResizeObserver.observe(this.body);
	}

	calcHeight(buttonHeight) {
		if (!buttonHeight) buttonHeight = 0;

		let heightSearchTop = document.querySelector(".search__form__wrapper")
			? document.querySelector(".search__form__wrapper").getBoundingClientRect()
					.height
			: 0;
		let heightInput = this.headerInput
			? this.headerInput.getBoundingClientRect().height
			: 0;

		if (document.querySelector(".predictive-search")) {
			let clientHeight = document.documentElement.clientHeight;
			let maxHeightAllowed =
				clientHeight -
				heightSearchTop -
				heightInput -
				buttonHeight -
				10;
			document.querySelector(
				".predictive-search",
			).style.maxHeight = `${maxHeightAllowed}px`;
		}
	}

	setupEventListeners() {
		this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
		this.input.addEventListener("focus", this.onFocus.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.addEventListener("keyup", this.onKeyup.bind(this));
		this.addEventListener("keydown", this.onKeydown.bind(this));
	}

	getQuery() {
		return this.input.value.trim();
	}

	onChange() {
		const newSearchTerm = this.getQuery();
		console.log('[DEBUG] onChange called, newSearchTerm:', newSearchTerm);
		if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
			// Remove the results when they are no longer relevant for the new search term
			// so they don't show up when the dropdown opens again
			this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
		}

		// Update the term asap, don't wait for the predictive search query to finish loading
		this.updateSearchForTerm(this.searchTerm, newSearchTerm);

		this.searchTerm = newSearchTerm;

		if (!this.searchTerm.length) {
			this.close(true);
			return;
		}

		this.getSearchResults(this.searchTerm);
	}

	onFormSubmit(event) {
		if (
			!this.getQuery().length ||
			this.querySelector('[aria-selected="true"] a') ||
			event.submitter.classList.contains("card__link")
		)
			event.preventDefault();
	}

	onFormReset(event) {
		super.onFormReset(event);
		if (super.shouldResetForm()) {
			this.searchTerm = "";
			this.abortController.abort();
			this.abortController = new AbortController();
			this.closeResults(true);
		}
	}

	onFocus() {
		const currentSearchTerm = this.getQuery();
		if (this.classList.contains("search-modal__form")) {
			if (this.headerBottom) {
				this.headerBottom.classList.add("header__bottom--visible");
			}
			if (this.promoModal) {
				this.promoModal.classList.remove("search__modal--hidden");
			}
		}

		if (!currentSearchTerm.length) {
			return;
		}

		if (this.searchTerm !== currentSearchTerm) {
			// Search term was changed from other search input, treat it as a user change
			this.onChange();
		} else if (this.getAttribute("results") === "true") {
			this.open();
			if (this.promoModal) {
				this.promoModal.classList.add("search__modal--hidden");
			}
		} else {
			this.getSearchResults(this.searchTerm);
		}
	}

	onFocusOut() {
		console.log('[DEBUG] onFocusOut called, activeElement:', document.activeElement?.tagName, document.activeElement?.className);
		if (this.classList.contains("search-modal__form")) {
			if (this.headerBottom) {
				this.headerBottom.classList.remove("header__bottom--visible");
			}
		}
		if (!this.classList.contains("search-modal__form")) {
			setTimeout(() => {
				console.log('[DEBUG] onFocusOut timeout, activeElement:', document.activeElement?.tagName, 'contains:', this.contains(document.activeElement));
				if (!this.contains(document.activeElement)) this.close();
			});
		}
	}

	onBlur() {
		if (this.headerInput) this.headerInput.blur();
	}

	onKeyup(event) {
		if (!this.getQuery().length) this.close(true);
		event.preventDefault();

		switch (event.code) {
			case "Enter":
				event.preventDefault();
				this.selectOption();
				break;
			case "Escape":
				this.closeResults(true);
				if (this.promoModal && this.classList.contains("search-modal__form")) {
					this.promoModal.classList.add("search__modal--hidden");
				}
				break;
		}

		if (this.getQuery().length) {
			this.hidePromoBlock();
		} else {
			this.showPromoBlock();
		}
	}

	onKeydown(event) {
		// Prevent the cursor from moving in the input when using the up and down arrow keys
		if (event.code === "ArrowUp" || event.code === "ArrowDown") {
			event.preventDefault();
		}
	}

	updateSearchForTerm(previousTerm, newTerm) {
		const searchForTextElement = this.querySelector(
			"[data-predictive-search-search-for-text]",
		);
		const currentButtonText = searchForTextElement?.innerText;
		if (currentButtonText) {
			if (
				currentButtonText.matchAll(new RegExp(previousTerm, "g")).length > 1
			) {
				// The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
				return;
			}
			const newButtonText = currentButtonText.replace(previousTerm, newTerm);
			searchForTextElement.innerText = newButtonText;
		}
		if (this.getQuery().length) {
			this.hidePromoBlock();
		} else {
			this.showPromoBlock();
		}
	}

	selectOption() {
		const selectedOption = this.querySelector(
			'[aria-selected="true"] a, button[aria-selected="true"]',
		);

		if (selectedOption) selectedOption.click();
	}

	getSearchResults(searchTerm) {
		const queryKey = searchTerm.replace(" ", "-").toLowerCase();
		console.log('[DEBUG] getSearchResults called, searchTerm:', searchTerm, 'queryKey:', queryKey);
		this.setLiveRegionLoadingState();

		if (this.cachedResults[queryKey]) {
			console.log('[DEBUG] Using cached results for:', queryKey);
			this.renderSearchResults(this.cachedResults[queryKey]);
			try { this.clickSearchTabs(); } catch (e) { console.warn('Predictive search: clickSearchTabs error', e); }
			try { this.calcHeight(); } catch (e) { console.warn('Predictive search: calcHeight error', e); }
			try { if (typeof colorSwatches === 'function') colorSwatches(); } catch (e) { console.warn('Predictive search: colorSwatches error', e); }
			return;
		}

		if (this.promoModal && this.classList.contains("search-modal__form")) {
			this.promoModal.classList.add("search__modal--hidden");
		}

		const fetchUrl = `${routes.predictive_search_url}?q=${encodeURIComponent(
			searchTerm
		)}&resources[type]=product,collection,article,page&resources[options][fields]=title,product_type,variants.title,vendor,tag,variants.sku&section_id=predictive-search`;
		console.log('[DEBUG] Fetching:', fetchUrl);

		fetch(fetchUrl, { signal: this.abortController.signal })
			.then((response) => {
				console.log('[DEBUG] Response status:', response.status, response.ok);
				if (!response.ok) {
					var error = new Error(response.status);
					this.close();
					throw error;
				}
				return response.text();
			})
			.then((text) => {
				console.log('[DEBUG] Response text length:', text.length);
				console.log('[DEBUG] Response text preview:', text.substring(0, 500));
				const sectionEl = new DOMParser()
					.parseFromString(text, "text/html")
					.querySelector("#shopify-section-predictive-search");
				console.log('[DEBUG] sectionEl found:', !!sectionEl);
				if (!sectionEl) {
					console.warn('Predictive search: section element not found in response');
					return;
				}
				const resultsMarkup = sectionEl.innerHTML;
				console.log('[DEBUG] resultsMarkup length:', resultsMarkup.length);
				// Save bandwidth keeping the cache in all instances synced
				this.allPredictiveSearchInstances.forEach(
					(predictiveSearchInstance) => {
						predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
					},
				);
				console.log('[DEBUG] Calling renderSearchResults...');
				this.renderSearchResults(resultsMarkup);
				console.log('[DEBUG] After renderSearchResults, open attr:', this.getAttribute('open'), 'results attr:', this.getAttribute('results'));
				try { this.clickSearchTabs(); } catch (e) { console.warn('Predictive search: clickSearchTabs error', e); }
				try { this.calcHeight(); } catch (e) { console.warn('Predictive search: calcHeight error', e); }
				try { if (typeof colorSwatches === 'function') colorSwatches(); } catch (e) { console.warn('Predictive search: colorSwatches error', e); }
				console.log('[DEBUG] getSearchResults completed successfully');
			})
			.catch((error) => {
				console.log('[DEBUG] Catch block triggered, error:', error, 'code:', error?.code);
				if (error?.code === 20) {
					// Code 20 means the call was aborted
					return;
				}
				console.warn('Predictive search: fetch error', error);
				this.close();
			});
	}

	setLiveRegionLoadingState() {
		this.statusElement =
			this.statusElement || this.querySelector(".predictive-search-status");
		this.loadingText =
			this.loadingText || this.getAttribute("data-loading-text");

		this.setLiveRegionText(this.loadingText);
		this.setAttribute("loading", true);
	}

	setLiveRegionText(statusText) {
		if (!this.statusElement) return;
		this.statusElement.setAttribute("aria-hidden", "false");
		this.statusElement.textContent = statusText;

		setTimeout(() => {
			if (this.statusElement) {
				this.statusElement.setAttribute("aria-hidden", "true");
			}
		}, 1000);
	}

	renderSearchResults(resultsMarkup) {
		console.log('[DEBUG] renderSearchResults called, markup length:', resultsMarkup.length);
		this.predictiveSearchResults.innerHTML = resultsMarkup;
		this.setAttribute("results", true);

		console.log('[DEBUG] Calling open()...');
		this.open();
		try {
			this.setLiveRegionResults();
		} catch (e) {
			console.warn('Predictive search: setLiveRegionResults error', e);
		}
		if (this.promoModal && this.classList.contains("search-modal__form")) {
			this.promoModal.classList.add("search__modal--hidden");
		}
	}

	clickSearchTabs() {
		const results = this.querySelectorAll(".predictive-search__results-list");
		if (results.length != 0) {
			results[0].classList.add("active");
			const firstTab = this.querySelector(".predictive-search__result-tab");
			if (firstTab) firstTab.classList.add("active");
			this.querySelectorAll(".predictive-search__result-tab").forEach((tab) => {
				tab.addEventListener("click", (event) => {
					event.preventDefault();
					const typeTarget = tab.dataset.typeTarget;
					this.querySelectorAll(".predictive-search__result-tab").forEach(
						(element) => {
							element.classList.remove("active");
						},
					);
					tab.classList.add("active");

					results.forEach((element) => {
						let resultsType = element.dataset.type;
						if (resultsType == typeTarget) {
							element.classList.add("active");
						} else {
							element.classList.remove("active");
						}
					});
				});
			});
		}
	}

	hidePromoBlock() {
		document.querySelector(".search__recomendation")
			? document.querySelector(".search__recomendation").classList.add("hidden")
			: false;
		document.querySelector(".search__line")
			? document.querySelector(".search__line").classList.add("hide")
			: false;
	}

	showPromoBlock() {
		document.querySelector(".search__recomendation")
			? document.querySelector(".search__recomendation").classList.remove("hidden")
			: false;
		document.querySelector(".search__line")
			? document.querySelector(".search__line").classList.remove("hide")
			: false;
	}

	setLiveRegionResults() {
		this.removeAttribute("loading");
		const countEl = this.querySelector("[data-predictive-search-live-region-count-value]");
		if (countEl) {
			this.setLiveRegionText(countEl.textContent);
		}
	}

	open() {
		console.log('[DEBUG] open() called');
		this.setAttribute("open", true);
		this.input.setAttribute("aria-expanded", true);
		this.isOpen = true;
		this.parentElement.parentElement.parentElement.classList.add('predictive-open');
		if (this.promoModal && this.classList.contains("search-modal__form")) {
			this.promoModal.classList.remove("search__modal--hidden");
		}
	}

	close(clearSearchTerm = false) {
		console.log('[DEBUG] close() called, clearSearchTerm:', clearSearchTerm);
		console.trace('[DEBUG] close() call stack');
		this.closeResults(clearSearchTerm);
		this.parentElement.parentElement.parentElement.classList.remove('predictive-open');
		this.isOpen = false;
	}

	closeResults(clearSearchTerm = false) {
		if (clearSearchTerm) {
			this.input.value = "";
			this.removeAttribute("results");
		}
		const selected = this.querySelector('[aria-selected="true"]');

		if (selected) selected.setAttribute("aria-selected", false);

		this.input.setAttribute("aria-activedescendant", "");
		this.removeAttribute("loading");
		this.removeAttribute("open");
		this.input.setAttribute("aria-expanded", false);
		this.predictiveSearchResults.removeAttribute("style");
		if (this.promoModal) {
			this.promoModal.classList.add("search__modal--hidden");
		}
	}
}

customElements.define("predictive-search", PredictiveSearch);